import { prefersReducedMotion } from "../utils/prefers-reduced-motion";

export default class MarqueeText {
  constructor(el) {
    this.el = el;
    this.track = el.firstElementChild;
    this.original = this.track.firstElementChild.cloneNode(true);
    this.speed = parseFloat(el.dataset.speed) || 0.5;

    this.bindEvents();
  }

  build() {
    this.track.replaceChildren(this.original.cloneNode(true));
    const unitWidth =
      this.track.firstElementChild.getBoundingClientRect().width;
    if (!unitWidth) return;
    const containerWidth = this.el.getBoundingClientRect().width;
    const needed = Math.ceil(containerWidth / unitWidth) + 2;

    for (let i = 1; i < needed; i++) {
      this.track.appendChild(this.original.cloneNode(true));
    }
    this.unitWidth = unitWidth;
  }

  bindEvents() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.build();
          if (this.unitWidth) {
            observer.disconnect();
          }
        }
      },
      { rootMargin: "200px 0px" },
    );
    observer.observe(this.el);

    if (!prefersReducedMotion()) {
      let ticking = false;
      window.addEventListener(
        "scroll",
        () => {
          if (!this.unitWidth) return;
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const x = -(window.scrollY * this.speed) % this.unitWidth;
            this.track.style.transform = `translate3d(${x}px, 0, 0)`;
            ticking = false;
          });
        },
        { passive: true },
      );
    }

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.build(), 150);
    });
  }
}
